import { render, staticRenderFns } from "./CreateAddressModal.vue?vue&type=template&id=75c065da"
import script from "./CreateAddressModal.vue?vue&type=script&lang=js"
export * from "./CreateAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports